// removed by extract-text-webpack-plugin
module.exports = {"banner":"_2zC2BzbJt7QHt08OYjFJZj"};


//////////////////
// WEBPACK FOOTER
// ../components/CookieBanner.module.scss
// module id = 471
// module chunks = 0